// FirstPromoter's domain extraction approach (reverse engineered)
export const extractDomainWithRegex = (
  hostname: string,
  minLength: number
): string => {
  // Regex pattern that handles both single TLDs (.com) and multi-part TLDs (.co.uk)
  const pattern = new RegExp(
    `^(?:.*\\.)?([a-zA-Z0-9\\-_]{${minLength},}\\.(?:\\w{2,8}|\\w{2,5}\\.\\w{2,4}))$`
  );
  return (pattern.exec(hostname) || [])[1] || "";
};

export const extractDomain = (hostname: string): string => {
  if (hostname === "localhost") return "localhost";

  // Try with min length 3 and 4, pick the longer result (FirstPromoter's approach)
  const domain3 = extractDomainWithRegex(hostname, 3);
  const domain4 = extractDomainWithRegex(hostname, 4);

  return domain3.length > domain4.length ? domain3 : domain4;
};
